import React, { useState, useEffect, useRef } from "react";
import {
  FiltroCascadaBody,
  FiltroCascadaBtn,
  FiltroCascadaBtnDanger,
  FiltroCascadaContainer,
  FiltroCascadaElementos,
  FiltroCascadaFooter,
  FiltroCascadaHeader,
  FiltroCascadaScrollContainer,
  ScrollDownButton,
  ScrollUpButton,
} from "./localStyle";
import Flecha from "./assets/Fecha";

const FiltroCascada = ({
  elementos,
  onClickCerrar,
  onClickAplicar,
  values,
  disabledBtn,
  callback,
}) => {
  //#region  ----------- constants ---------------
  const [seleccionarTodo, setSeleccionarTodo] = useState(
    values.includes("Todos") ? true : false
  );
  const [elementosSeleccionados, setElementosSeleccionados] = useState({});
  const activateScroll = elementos.length > 10;
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------
  const manejarSeleccionarTodo = () => {
    const nuevoEstado = !seleccionarTodo;
    setSeleccionarTodo(nuevoEstado);
    const nuevosElementosSeleccionados = { ...elementosSeleccionados };
    for (let elemento in nuevosElementosSeleccionados) {
      nuevosElementosSeleccionados[elemento] = nuevoEstado;
    }
    setElementosSeleccionados(nuevosElementosSeleccionados);
    if (callback) {
      callback(createArray(nuevosElementosSeleccionados));
    }
  };

  const manejarCambioElemento = (nombre) => {
    const nuevosElementosSeleccionados = {
      ...elementosSeleccionados,
      [nombre]: !elementosSeleccionados[nombre],
    };
    setElementosSeleccionados(nuevosElementosSeleccionados);
    const todosSeleccionados = Object.values(
      nuevosElementosSeleccionados
    ).every((valor) => valor === true);
    setSeleccionarTodo(todosSeleccionados);
    if (callback) {
      callback(createArray(nuevosElementosSeleccionados));
    }
  };

  const createArray = (items) => {
    return Object.keys(items).filter((propiedad) => items[propiedad]);
  };

  const containerRef = useRef(null);

  const onClickUp = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollTop - 48,
        behavior: "smooth",
      });
    }
  };

  const onClickDown = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollTop + 48,
        behavior: "smooth",
      });
    }
  };
  //#endregion --------- funciones ---------------

  //#region --------- useEffect ---------------
  useEffect(() => {
    let nuevosElementosSeleccionados = {};
    if (values.includes("Todos")) {
      nuevosElementosSeleccionados = elementos.reduce(
        (acc, elemento) => ({
          ...acc,
          [elemento.nombre]: true,
        }),
        {}
      );
    } else {
      nuevosElementosSeleccionados = elementos.reduce(
        (acc, elemento) => ({
          ...acc,
          [elemento.nombre]: values.includes(elemento.nombre),
        }),
        {}
      );
    }
    setElementosSeleccionados(nuevosElementosSeleccionados);
  }, [values, elementos]);
  //#endregion --------- useEffect ---------------

  return (
    <FiltroCascadaContainer>
      <FiltroCascadaHeader>
        <label>
          <input
            className="FiltroCascada-checkbox"
            type="checkbox"
            checked={seleccionarTodo}
            onChange={manejarSeleccionarTodo}
          />
          Todos
        </label>
      </FiltroCascadaHeader>
      <FiltroCascadaBody>
        <FiltroCascadaElementos scroll={activateScroll} ref={containerRef}>
          {elementos.map((elemento) => (
            <label key={elemento.nombre}>
              <input
                className="FiltroCascada-checkbox"
                type="checkbox"
                checked={elementosSeleccionados[elemento.nombre]}
                onChange={() => manejarCambioElemento(elemento.nombre)}
              />
              {elemento.nombre}
            </label>
          ))}
        </FiltroCascadaElementos>
        {activateScroll && (
          <FiltroCascadaScrollContainer>
            <ScrollUpButton onClick={onClickUp}>
              <Flecha />
            </ScrollUpButton>
            <ScrollDownButton onClick={onClickDown}>
              <Flecha />
            </ScrollDownButton>
          </FiltroCascadaScrollContainer>
        )}
      </FiltroCascadaBody>
      {!disabledBtn && (
        <FiltroCascadaFooter>
          <FiltroCascadaBtnDanger onClick={onClickCerrar}>
            Cerrar
          </FiltroCascadaBtnDanger>
          <FiltroCascadaBtn
            onClick={() =>
              onClickAplicar(
                seleccionarTodo
                  ? ["Todos"]
                  : createArray(elementosSeleccionados)
              )
            }
          >
            Aplicar cambios
          </FiltroCascadaBtn>
        </FiltroCascadaFooter>
      )}
    </FiltroCascadaContainer>
  );
};

export default FiltroCascada;
